(function () {
  "use strict";

  // Customers write things like: My spa is 16'1" x 8'7" (rounded corners) & I
  // haven't picked a colour yet. The old validator rejected apostrophes, inch
  // marks, parentheses and ampersands outright, blocked a blank phone number
  // even though the field is optional, and reported all of it with nothing but
  // a red border. Validate shape, never characters, and always say what's wrong.

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE_SEPARATORS = /[\s\-().]/g;
  var PHONE_PATTERN = /^\+?[0-9]{7,15}$/;
  var MAX_NAME_LENGTH = 100;
  var MAX_MESSAGE_LENGTH = 5000;

  function t(key, fallback) {
    var strings = window.spamigoContactStrings || {};
    return strings[key] || fallback;
  }

  // Each entry validates one control and returns an error message, or "" when
  // the value is acceptable. Blank is only an error where required is true.
  var FIELDS = [
    {
      selector: ".js-contact-us__input-name",
      required: true,
      validate: function (value) {
        if (!value) return t("name_required", "Please enter your name.");
        if (value.length > MAX_NAME_LENGTH) {
          return t("name_too_long", "Please shorten your name.");
        }
        return "";
      }
    },
    {
      selector: ".js-contact-us__input-email",
      required: true,
      validate: function (value) {
        if (!value) return t("email_required", "Please enter your email address.");
        if (!EMAIL_PATTERN.test(value)) {
          return t("email_invalid", "Please enter a valid email address, like name@example.com.");
        }
        return "";
      }
    },
    {
      // Optional. Only checked when the customer actually types something, and
      // spaces, dashes, dots and brackets are all normal ways to write a number.
      selector: ".js-contact-us__input-tel",
      required: false,
      validate: function (value) {
        if (!value) return "";
        if (!PHONE_PATTERN.test(value.replace(PHONE_SEPARATORS, ""))) {
          return t("phone_invalid", "Please enter a valid phone number, or leave this field empty.");
        }
        return "";
      }
    },
    {
      selector: ".s-contact-us__select",
      required: true,
      validate: function (value) {
        if (!value) return t("model_required", "Please choose your hot tub.");
        return "";
      }
    },
    {
      selector: ".s-contact-us__textarea",
      required: true,
      validate: function (value) {
        if (!value) return t("message_required", "Please enter your message.");
        if (value.length > MAX_MESSAGE_LENGTH) {
          return t("message_too_long", "Please shorten your message.");
        }
        return "";
      }
    }
  ];

  if (customElements.get("s-contact-us")) return;

  customElements.define(
    "s-contact-us",
    class SectionContactUs extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("form");
        if (!this.form) return;

        this.onSubmit = this.onSubmit.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onInput = this.onInput.bind(this);

        this.form.addEventListener("submit", this.onSubmit);
        // blur does not bubble, so listen on the way down.
        this.form.addEventListener("blur", this.onBlur, true);
        this.form.addEventListener("input", this.onInput);
        this.form.addEventListener("change", this.onInput);
        // Keep native required/type validation as a fallback until this
        // validator has loaded and its listeners are attached.
        this.form.noValidate = true;
      }

      disconnectedCallback() {
        if (!this.form) return;

        this.form.removeEventListener("submit", this.onSubmit);
        this.form.removeEventListener("blur", this.onBlur, true);
        this.form.removeEventListener("input", this.onInput);
        this.form.removeEventListener("change", this.onInput);
        this.form.noValidate = false;
      }

      fields() {
        var self = this;
        return FIELDS.map(function (field) {
          return { config: field, input: self.querySelector(field.selector) };
        }).filter(function (entry) {
          return entry.input;
        });
      }

      fieldFor(input) {
        return this.fields().filter(function (entry) {
          return entry.input === input;
        })[0];
      }

      // The error element is emitted by the section next to each control.
      errorElementFor(input) {
        var id = input.getAttribute("aria-describedby");
        return id ? this.querySelector("#" + id) : null;
      }

      showError(input, message) {
        var label = input.closest("label");
        var errorElement = this.errorElementFor(input);

        if (label) label.classList.toggle("s-contact-us__label--error", Boolean(message));
        input.setAttribute("aria-invalid", message ? "true" : "false");

        if (errorElement) {
          errorElement.textContent = message;
          errorElement.hidden = !message;
        }
      }

      validateField(entry) {
        var value = (entry.input.value || "").trim();
        var message = entry.config.validate(value);
        this.showError(entry.input, message);
        return message === "";
      }

      onSubmit(event) {
        var self = this;
        var invalid = this.fields().filter(function (entry) {
          return !self.validateField(entry);
        });

        if (!invalid.length) return; // let the browser post the form

        event.preventDefault();
        invalid[0].input.focus();
        if (typeof invalid[0].input.scrollIntoView === "function") {
          invalid[0].input.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }

      onBlur(event) {
        var entry = this.fieldFor(event.target);
        // Don't scold someone for an empty field they merely tabbed past.
        if (!entry) return;
        if (!entry.config.required && !(entry.input.value || "").trim()) {
          this.showError(entry.input, "");
          return;
        }
        this.validateField(entry);
      }

      // Typing only ever clears an error, never raises one.
      onInput(event) {
        var entry = this.fieldFor(event.target);
        if (!entry) return;
        if (entry.input.getAttribute("aria-invalid") !== "true") return;
        this.validateField(entry);
      }
    }
  );
})();
